<template>
  <v-file-input
    accept=".xlsx"
    :label="$t('forms.matrixInputFile.label')"
    name="matrix"
    :counter="isMultiple"
    :counter-string="counterString"
    :multiple="true"
    prepend-icon="mdi-file-table"
    :rules="[required, fileType, limitFileNumber]"
    @change="setFiles"
  >
    <template v-slot:selection="{ file, index }">
      <div>
        <matrix-status-badge :index="index"></matrix-status-badge>
        {{ file.name }}
      </div>
    </template>
  </v-file-input>
</template>

<script lang="ts">
import Vue from 'vue';
import { TranslateResult } from 'vue-i18n';
import MatrixStatusBadge from '@/components/matrix-status-badge.vue';
import { getMatrixCount, setFiles } from '@/modules/matrix';

export default Vue.extend({
  name: 'MatrixInputFile',
  components: {
    MatrixStatusBadge
  },
  props: {
    max: {
      type: Number,
      default: 1
    }
  },
  computed: {
    isMultiple(): boolean {
      return this.max > 1;
    },
    counterString(): string {
      return this.$tc('forms.matrixInputFile.counter', getMatrixCount());
    }
  },
  methods: {
    setFiles,
    required(files: File[]): boolean | TranslateResult {
      return files !== undefined || this.$t('forms.matrixInputFile.required');
    },
    fileType(files: File[]): boolean | TranslateResult {
      if (files === undefined) {
        return false;
      }

      const fileListWithNotValidType: File[] = files.filter(
        file => file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );

      return fileListWithNotValidType.length === 0 || this.$tc('forms.matrixInputFile.type', files.length);
    },
    limitFileNumber(files: File[]): boolean | TranslateResult {
      return (files !== undefined && files.length <= this.max) || this.$t('forms.matrixInputFile.limit');
    }
  }
});
</script>

<style lang="scss">
.v-file-input div.v-file-input__text {
  display: block;
}
</style>
